module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_telugu.ac843e7d.mp3";